import { useEffect, useCallback } from 'react';
import { alert } from 'utils';
import { signMessage } from 'utils/eth';
import { getSigner } from 'web3/utils';
import { useWeb3, useWeb3React } from 'web3/hooks';

import { useDispatch } from 'react-redux';
import { loginWithBox } from 'modules/auth/auth.actions';

const Alert = alert.Alert();

export function useSignAddress(address, metamask, setSig) {
  return useEffect(() => {
    if (!address || !metamask) return;
    const sign = async () => {
      try {
        const signer = getSigner();
        const { msg, signature } = await signMessage(signer, address);
        return setSig([null, signature, msg]);
      } catch (err) {
        Alert.alert(err.message);
        return setSig([err.message]);
      }
    };
    sign();
  }, [address]); // eslint-disable-line
}

export function useLoginWithMM(close) {
  useWeb3();
  const { account, metamask } = useWeb3React();
  const address = account;
  const dispatch = useDispatch();
  const logIn = useCallback(async () => {
    try {
      if (!metamask || !address) return Alert.alert('Please enable Metamask to log in.');
      const signer = getSigner();
      const { signature, msg } = await signMessage(signer, address);
      const success = await dispatch(loginWithBox({ signature, address, msg }));
      success && close && close();
      return success;
    } catch (err) {
      console.error(err); // eslint-disable-line
    }
  }, [address, dispatch, close]);
  return logIn;
}
